/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/** */
export interface TimeZoneInterface {
    /**
     * @todo write description
     */
    setTimeZone(timeZone: string): Promise<setTimeZoneResponse>;
}

export type setTimeZoneResponse = {
    rebootRequired?: boolean;
};

export function supportsTimeZone(platform: unknown): platform is TimeZoneInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PmcMessageType.TimeZoneSet);
    }
    return platform instanceof Object && 'setTimeZone' in platform;
}
